module.exports = __webpack_public_path__ + "media/images/landing/banner_logo_01.es-5bbf30f67a1d4c75da4ac8f920e978b0.png";